import type { AppError } from "./app-error";
import { useModalService } from "../../services/modal-service";
import { ErrorFactory } from "./error-factory"
import ErrorModal from "../../components/errorHandling/ErrorModal.vue"


export function showUIError(error: AppError) {
    const modal = useModalService();
    modal.showModal(ErrorModal, {error: ErrorFactory.fromError(error)}, {showTitle:false, showCloseButton: false})
}